import createUrl, { DOMAIN } from '../urlCreator/urlCreator';

/**
 * PC用のso-net共通ヘッダー
 */
const CommonHeaderForPC = () => {
    return (
        <div className="gHd2017_header gHd2017_PC">
            <div className="gHd2017_sonyHeader">
                <span className="gHd2017_sonyHeaderInner">
                    <a href={'https://www.sony.co.jp/'}>
                        <img
                            itemProp="logo"
                            src={createUrl(DOMAIN.SONET, '/common/hf1704/img/logo-sony.png')}
                            alt="Sony"
                        />
                    </a>
                </span>
            </div>
            <noscript className="gHd2017_noscript">
                このページはJavaScriptを使用しています。JavaScriptを有効にしてご覧ください。
                <br />
                設定方法は「
                <a href={createUrl(DOMAIN.SUPPORT, '/fa/faq/web/knowledge2019.html')}>
                    JavaScriptを有効にする方法を知りたい
                </a>
                」でご案内しております。
            </noscript>

            <div className="gHd2017_headerInner">
                <div className="gHd2017_logoWrapper">
                    <div itemType="http://schema.org/Organization" className="gHd2017_logo">
                        <a itemProp="url" href={createUrl(DOMAIN.SONET, '/?SmRcid=gn_hd_slogo')}>
                            <img
                                itemProp="logo"
                                src={createUrl(DOMAIN.SONET, '/common/hf1704/img/logo.png')}
                                alt="So-net"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div className="gHd2017_parsonal" />
        </div>
    );
};

export default CommonHeaderForPC;
